module.exports = __webpack_public_path__ + "img/no_promocode.a1a5a2ee.svg";